import {EVENTS_NAME} from '../config.js'

const {LEAD_TRIGGERED_FAVORITES} = EVENTS_NAME

// INPUT:  event='Lead Triggered', page_name_origin='listado de favoritos'
// OUTPUT: ['Leads de favoritos']

export const getFavoritesEvents = ({event, properties}) => {
  const matches =
    event === LEAD_TRIGGERED_FAVORITES.EVENT &&
    properties.page_name_origin === LEAD_TRIGGERED_FAVORITES.PAGE_NAME_ORIGIN

  if (!matches) return []

  return [LEAD_TRIGGERED_FAVORITES.EVENT_OPTIMIZELY]
}
